import React, { useEffect, useState, useRef } from 'react';
import throttle from 'lodash.throttle';
import { scrollToSection } from '../../../utils/scrollUtils';

import {
  WrapperNavMenu,
  SchaduleElementsMenu,
  NavMenu,
  NavItem,
  NavLinks,
  SchaduleScrollButtomOne,
  SchaduleScrollButtomTwo,
  ScrollButton,
  ButtonsScroll
} from './navMenuCardapioElements';

function NavMenuCardapio() {
  const menuRef = useRef(null);
  const buttonsRef = useRef(null);
  const navLinkRefs = useRef([]);
  const [activeMenuFixed, setActiveMenuFixed] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const isScrollingRef = useRef(false); // ← Previne conflitos

  const menuItems = [
    'Couvert',
    'Saladas',
    'Piraputanga',
    'Pintado',
    'Tilápia',
    'Pacu',
    'Carne Bovina',
    'Adicionais',
    'Para uma Pessoa',
    'Porções',
    'Bebidas',
    'Sucos',
    'Coquetéis',
    'Drinks sem Álcool',
    'Batidas',
    'Doses',
    'Cafés',
    'Sobremesas',
  ];

  // Scroll Control Functions (otimizado)
  const scrollLeft = () => {
    if (buttonsRef.current) {
      buttonsRef.current.scrollBy({ left: -150, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (buttonsRef.current) {
      buttonsRef.current.scrollBy({ left: 150, behavior: 'smooth' });
    }
  };

  // Fixar menu no topo ao rolar (otimizado)
  useEffect(() => {
    const throttledScroll = throttle(() => {
      const shouldBeFixed = window.scrollY > 250;
      setActiveMenuFixed(shouldBeFixed);
    }, 100); // Reduzido de 200 para 100ms

    window.addEventListener('scroll', throttledScroll, { passive: true }); // ← passive: true para performance
    return () => {
      window.removeEventListener('scroll', throttledScroll);
      throttledScroll.cancel();
    };
  }, []);

  // Detectar sessão visível (otimizado)
  useEffect(() => {
    const sectionIds = menuItems.map(item =>
      item
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '_')
    );

    const handleScroll = throttle(() => {
      if (isScrollingRef.current) return; // ← Previne conflito durante scroll programático

      const menuHeight = menuRef.current?.offsetHeight || 0;
      let currentSection = sectionIds[0];

      for (let id of sectionIds) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top - menuHeight <= 100) {
            currentSection = id;
          } else {
            break;
          }
        }
      }

      setActiveSection(currentSection);
    }, 100);

    window.addEventListener('scroll', handleScroll, { passive: true }); // ← passive: true
    return () => {
      window.removeEventListener('scroll', handleScroll);
      handleScroll.cancel();
    };
  }, [menuItems]);

  // Scroll automático do menu horizontal (otimizado com requestAnimationFrame)
  useEffect(() => {
    if (!activeSection || !buttonsRef.current) return;

    const sectionIds = menuItems.map(item =>
      item
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '_')
    );

    const idx = sectionIds.indexOf(activeSection);

    if (idx !== -1 && navLinkRefs.current[idx]) {
      const container = buttonsRef.current;
      const target = navLinkRefs.current[idx];

      if (container && target) {
        // ← Usa requestAnimationFrame para melhor performance
        requestAnimationFrame(() => {
          const containerWidth = container.clientWidth;
          const targetLeft = target.offsetLeft;
          const targetWidth = target.clientWidth;

          const scrollTo = targetLeft - (containerWidth / 2) + (targetWidth / 2);

          // ← Scroll suave usando scrollTo ao invés de scrollLeft direto
          container.scrollTo({
            left: scrollTo,
            behavior: 'smooth'
          });
        });
      }
    }
  }, [activeSection, menuItems]);

  // Handler de clique otimizado
  const handleNavClick = (id, index) => {
    isScrollingRef.current = true; // ← Bloqueia o observer temporariamente
    
    scrollToSection(id, 100);

    // ← Desbloqueia após o scroll terminar
    setTimeout(() => {
      isScrollingRef.current = false;
    }, 100); // Tempo suficiente para a animação terminar
  };

  return (
    <WrapperNavMenu ref={menuRef} activeMenuFixed={activeMenuFixed}>
      <SchaduleElementsMenu>
        <NavMenu activeMenuFixed={activeMenuFixed} ref={buttonsRef}>
          {menuItems.map((item, index) => {
            const id = item
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .replace(/\s+/g, '_');
            const isActive = activeSection === id;

            return (
              <NavItem key={index}>
                <NavLinks
                  ref={el => navLinkRefs.current[index] = el}
                  className={isActive ? 'active' : ''}
                  onClick={() => handleNavClick(id, index)}
                >
                  {item}
                </NavLinks>
              </NavItem>
            );
          })}
        </NavMenu>
        <ButtonsScroll>
          <SchaduleScrollButtomOne>
            <ScrollButton onClick={scrollLeft}>{'<'}</ScrollButton>
          </SchaduleScrollButtomOne>
          <SchaduleScrollButtomTwo>
            <ScrollButton onClick={scrollRight}>{'>'}</ScrollButton>
          </SchaduleScrollButtomTwo>
        </ButtonsScroll>
      </SchaduleElementsMenu>
    </WrapperNavMenu>
  );
}

export default NavMenuCardapio;